/*
 * @Descripttion: 
 * @version: 
 * @Author: yuhongyou
 * @Date: 2021-04-25 14:19:20
 * @LastEditors: yuhongyou
 * @LastEditTime: 2021-11-04 15:24:39
 */
let timeInit = {}
timeInit.install = function (Vue, options) {
  Vue.prototype.timeInit = {
    getYM: function (date) {
      let dateInit = new Date(date)
      return dateInit.getFullYear() + '-' + ((dateInit.getMonth()+1) < 10 ? '0' + (dateInit.getMonth()+1) : (dateInit.getMonth()+1))
    },
    getYMD: function (date) {
      let dateInit = new Date(date)
      return dateInit.getFullYear() + '-' + ((dateInit.getMonth()+1) < 10 ? '0' + (dateInit.getMonth()+1) : (dateInit.getMonth()+1)) + '-' + (dateInit.getDate() < 10 ? '0' + dateInit.getDate() : dateInit.getDate())
    },
    getHMS: function (date) {
      let dateInit = new Date(date)
      return (dateInit.getHours() < 10 ? '0' + dateInit.getHours() : dateInit.getHours()) + ':' + (dateInit.getMinutes() < 10 ? '0' + dateInit.getMinutes() : dateInit.getMinutes()) + ':' + (dateInit.getSeconds() < 10 ? '0' + dateInit.getSeconds() : dateInit.getSeconds())
    },
    getYMDHMS: function (date) {
      let dateInit = new Date(date)
      return dateInit.getFullYear() + '-' + ((dateInit.getMonth()+1) < 10 ? '0' + (dateInit.getMonth()+1) : (dateInit.getMonth()+1)) + '-' + (dateInit.getDate() < 10 ? '0' + dateInit.getDate() : dateInit.getDate()) + ' ' + (dateInit.getHours() < 10 ? '0' + dateInit.getHours() : dateInit.getHours()) + ':' + (dateInit.getMinutes() < 10 ? '0' + dateInit.getMinutes() : dateInit.getMinutes()) + ':' + (dateInit.getSeconds() < 10 ? '0' + dateInit.getSeconds() : dateInit.getSeconds())
    },
  }
};
export default timeInit;